import React, { useEffect, useState } from "react";
import { useCart } from "../contexts/CartContext";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import "../styles/Cart.css";

const Cart = () => {
  const { user, loading } = useAuth();
  const { cartItems, removeFromCart, clearCart, increaseQuantity, decreaseQuantity } = useCart();
  const [recentlyUpdated, setRecentlyUpdated] = useState(null);
  const navigate = useNavigate(); // 👉 importar esto  
  const [toastMessage, setToastMessage] = useState("");

  if (loading) return null; // O muestra un loader opcional

  const total = cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0);

  const showCheck = (id) => {
    setRecentlyUpdated(id);
    setTimeout(() => setRecentlyUpdated(null), 1000);
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-container">
        <h2 className="cart-title">Tu carrito está vacío</h2>
        <Link to="/" className="cart-back-link">Volver al menú</Link>
      </div>
    );
  }

  const showToast = (message) => {
    setToastMessage(message);
    setTimeout(() => setToastMessage(""), 2500);
  };

  return (
    <div className="cart-container">
      <div className="category-header">
        <Link to="/" className="back-link">
          <i className="fas fa-arrow-left"></i>
        </Link>
        <h2 className="cart-title">Tu carrito</h2>
      </div>
      <ul className="cart-list">
        {cartItems.map((item) => (
          <li key={item.id} className="cart-item">
            <div className="cart-item-info">
              <span className="cart-item-name">{item.name}</span>
              <div className="cart-quantity-controls">
                <button onClick={() => { decreaseQuantity(item.id); showCheck(item.id); }}>−</button>
                <span className="cart-item-quantity">{item.quantity}</span>
                <button onClick={() => { increaseQuantity(item); showCheck(item.id); }}>+</button>
              </div>
              <span className="cart-item-price">
                ${(item.price * item.quantity).toFixed(2)}
              </span>
            </div>
            <button className="cart-remove-button" onClick={() => removeFromCart(item.id)}>
              Eliminar
            </button>
          </li>
        ))}
      </ul>
      <div className="cart-total">
        <strong>Total:</strong> ${total.toFixed(2)}
      </div>
      <div className="cart-buttons">
        <button className="cart-clear-button" onClick={clearCart}>Vaciar carrito</button>
        <button
          className="cart-checkout-button"
          onClick={() => {
            if (user) {
              navigate("/checkout");
            } else {
              showToast("Debes iniciar sesión para finalizar el pedido");
              setTimeout(() => navigate("/login"), 2000);
            }
          }}
        >
          Finalizar pedido
        </button>
      </div>

      {toastMessage && (
        <div className="cart-toast">
          {toastMessage}
        </div>
      )}
    </div>
  );
};

export default Cart;
